<template>
  <div class="pa-10">
    <v-tabs v-model="tab" dark background-color="primary">
      <v-tab v-for="tab in tabs" :key="tab">
        {{ tab }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <recharge></recharge>
      </v-tab-item>
      <v-tab-item>
        <shopping></shopping>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import Recharge from "../components/reports/Recharge.vue";
import Shopping from "../components/reports/Shopping.vue";
export default {
  components: { Recharge, Shopping },
  data() {
    return {
      tab: 0,
      tabs: ["Recharge History", "Order History"],
    };
  },
};
</script>

<style>
</style>